






























































import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import { checkObjectArrayDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';
import MemberSearch from '@adobe/edex/frontend/views/course/settings/course-settings-member-search.vue';

export default {
  mixins: [changeLogMixin],
  props: {
    initialInstructors: {
      type: Array,
    },
    initialStaff: {
      type: Array,
    },
  },
  data() {
    return {
      instructors: [],
      staff: [],
    };
  },
  components: {
    MemberSearch,
  },
  watch: {
    initialInstructors(current, previous) {
      if (current && !previous) {
        this.instructors = [...current];
      } else {
        this.instructors = [];
      }
    },
    initialStaff(current, previous) {
      if (current && !previous) {
        this.staff = [...current];
      } else {
        this.staff = [];
      }
    },
    ...['instructors', 'staff'].reduce((acc, name) => {
      const diffSource =
        name === 'instructors' ? 'initialInstructors' : 'initialStaff';

      acc[name] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name,
            path: ['educators', name],
            data: current.map(getID),
            hasDiff: checkObjectArrayDiff(this[diffSource], this[name]),
          });
        }
      };

      return acc;
    }, {}),
  },
  methods: {
    onMemberChanged({ name, data }) {
      this[name] = data;
    },
    resetChanges() {
      this.instructors = this.initialInstructors;
      this.staff = this.initialStaff;
    },
  },
};
